<template>
  <div class="outpatient-charge-container">
    <div class="filter-section">
      <el-card class="filter-card">
        <el-form :model="queryParams" inline>
          <el-form-item label="统计时间:">
            <el-date-picker
                size="mini"
                v-model="timeRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="handleTimeChange"
            />
          </el-form-item>

          <el-form-item label="类型:">
            <el-select v-model="queryParams.classId"  size="mini" @change="loadData" clearable filterable>
              <el-option
                  v-for="(item,index) in financeclassOptions" :key="item.id"
                  :label="item.label"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="loadData" :loading="loading">
              查询
            </el-button>
            <el-button @click="resetQuery" size="mini">
              重置
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <!-- 内容区域 - 可滚动 -->
    <div class="content-section">
      <!-- 总体统计卡片 -->
<!--
      <el-row :gutter="0" class="stats-row">
        <el-col :xs="12" :sm="6" :md="6" :lg="6">
          <el-card class="stat-card income-card" shadow="hover">
            <div class="stat-content">
              <div class="stat-title">支出</div>
              <div class="stat-info">
                <div class="stat-values-row">
                  <div class="stat-value-item">
                    <div class="value-label">当期</div>
                    <div class="stat-value">¥{{ processData(1, statisticsData) }}</div>
                  </div>
                  <div class="stat-divider">/</div>
                  <div class="stat-value-item">
                    <div class="value-label">累计</div>
                    <div class="stat-value">¥{{ processData(1, yearlyStatisticsData) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="6">
          <el-card class="stat-card expense-card" shadow="hover">
            <div class="stat-content">
              <div class="stat-title">收入</div>
              <div class="stat-info">
                <div class="stat-values-row">
                  <div class="stat-value-item">
                    <div class="value-label">当期</div>
                    <div class="stat-value">¥{{ processData(2, statisticsData) }}</div>
                  </div>
                  <div class="stat-divider">/</div>
                  <div class="stat-value-item">
                    <div class="value-label">累计</div>
                    <div class="stat-value">¥{{ processData(2, yearlyStatisticsData) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
-->


      <!-- 各费用类型明细统计 - 独立标签页 -->
      <el-tabs v-model="activeTab1" type="border-card" class="separate-tab">
        <el-tab-pane label="资金明细统计" name="detail">
          <el-table
              :data="tableData"
              border
              stripe
              v-loading="loading"
              empty-text="暂无数据"
              class="detail-table"
              style="width: 100%"
          >
            <el-table-column type="index" label="序号" align="center"/>
            <el-table-column v-for="(col, inx) in tableRows1" :key="inx" :type="col.type" :prop="col.prop"
                             :label="col.name" :render-header="labelHead" align="center"
                             :min-width="getColumnWidth(col.label,col.prop,tableData)">
              <template #default="{ row }">
                {{ safeGetMappedValue(col, row) }}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :page-sizes="[8,16,32]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize"
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>


  </div>
</template>

<script>
import {
  getChargesDetialPage,
  getOutpatientChargeStatistics
} from "@/api/outpatientChargeStatistics/outpatientChargeStatistics";
import dayjs from "dayjs";
import {
  getDoctordisposeOneById,
  getDoctordisposePage,
  getDrxMainRefundList
} from "@/api/reservation/outpatientChargeList";
import {getWestDetail} from "@/api/reservation/outpatientCharge";
import {getFinancialDetailsPage, getFinancialDetailsStatistics} from "@/api/financialDetails/financialDetails";
import {getFinanceclassList} from "@/api/clasificacionContable/clasificacionContable";

export default {
  name: 'OutpatientChargeReport',
  data() {
    return {
      dosaUntOptions: [],//单位
      medicationFrequencyOptions: [],
      financeclassOptions: [],
      typeOptions: [{id:1,label:'支出'},{id:2,label:'收入'}],
      typeOptions2: [{id:1,label:'收入'},{id:0,label:'支出'}],
      queryConditionForm: {
        timeFrameArr: [
          dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ],
        nuyState: 0,
        chargeStatus: 1,
      },
      currentDbData: null,
      westChargesDetailDiagnosisModalVisible: false,
      westModalVisible: false,
      disposeDetialModalVisible: false,
      westChargesDetailData: [],
      westData: [],
      disposeData: [],
      westPatientData: {
        name: '',
        age: '',
        sex: '',
        pricingType: ''
      },

      disposePatientData: {
        name: '',
        age: '',
        sex: '',
        pricingType: ''
      },
      sexOptions: [{id: 1, label: '男'}, {id: 2, label: '女'}],
      pricingTypeOptions: [{id: 1, label: '医嘱划价'}, {id: 2, label: '手工划价'}, {id: 3, label: '互联网划价'}],
      chargeStatusOptions: [{id: 0, label: '未收费'}, {id: 1, label: '已收费'}, {id: 2, label: '已申请退费'}, {
        id: 3,
        label: '已退费'
      }],
      dataSourceOptions: [{id: 1, label: '医嘱'}, {id: 2, label: '护士'}, {id: 3, label: '检查'}, {
        id: 4,
        label: '检验'
      }, {id: 5, label: '其他'}],
      westChargesDetailRows: [
        {name: "业务来源", prop: "busForm", type: "", op: 'busFormOptions'},
        {name: "开单科室", prop: "bilgDepName", type: ""},
        {name: "开单医生", prop: "bilgDrName", type: ""},
        {name: "实际金额", prop: "paidAmt", type: ""},
        {name: "实际价格", prop: "paidPric", type: ""},
        {name: "冲销状态", prop: "nuyState", type: "", op: 'nuyStateOptions'},
        {name: "冲销金额", prop: "nuyAmt", type: ""},
        {name: "冲销数量", prop: "nuyCnt", type: ""},
      ],
      westTableRows: [
        {name: "药品名称", prop: "drugName"},
        {name: "规格描述", prop: "drugSpec"},
        {name: "数量", prop: "cntStr"},
        {name: "给药方式", prop: "medcWayId", op: 'medicationFrequencyOptions'},
        {name: "成本金额", prop: "purcAmt"},
        {name: "销售金额", prop: "saleAmt"},],

      disposeTableRows: [
        {name: "系统序号", prop: "id"},
        {name: "处置名称", prop: "costname"},
        {name: "处置类型", prop: "dataSource", op: 'dataSourceOptions'},
        {name: "收费状态", prop: "chargeStatus", op: 'chargeStatusOptions'},
        {name: "频率数量", prop: "frquCnt"},
        {name: "执行单价", prop: "executionPrice"},
        {name: "执行金额", prop: "executionAmount"},
        {name: "执行频率", prop: "exeFrquId", op: 'medicationFrequencyOptions'},
        {name: "数量", prop: "num"},
        {name: "申请退数量", prop: "applyNum"},
      ],
      busFormOptions: [{id: 0, label: '医嘱'}, {id: 1, label: '手工'}, {id: 2, label: '护理'}, {id: 3, label: '网络'},],
      nuyStateOptions: [{id: 0, label: '否'}, {id: 1, label: '冲销原单'}, {id: 2, label: '冲销负单'}],
      pageNum: 1, //当前页currentPage
      pageSize: 8,
      totalSize: 10, //总条数
      loading: false,
      activeTab1: 'detail',
      activeTab2: 'summary',
      tableData: [],
      statisticsData: [],
      yearlyStatisticsData: [],
      tableRows1: [
        {prop: "busId", name: "单据编号"},
        {prop: "type", name: "单据类型",op:'typeOptions'},
        {prop: "agoAmt", name: "变化前金额"},
        {prop: "amount", name: "金额"},
        {prop: "aftAmt", name: "变化后金额"},
        {prop: "createTime", name: "创建时间"},
      ],
      statsData: {
        cashAmt: 0,
        costAmt: 0,
        detailStaticsRespVOS: [],
        distAmt: 0,
        groupAmt: 0,
        paidAmt: 0
      },
      timeRange: [
        dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      ],
      queryParams: {
        type: null,
        classId: 101,
        startTime: dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      },
    }
  },

  mounted() {
    this.dosaUntOptions = this.$store.getters['preload/getDosaUntListOption'];
    this.medicationFrequencyOptions = this.$store.getters['preload/getMedicationFrequencyOptions'];
    this.loadData()
    this.loadDataStatistics()
    this.getFinanceclassList()
  },
  methods: {
    getClassNameById(id){
      return  this.financeclassOptions.find(item => item.id === id)?.label || '未知';
    },
    async getFinanceclassList() {
      const res = await getFinanceclassList({status: 1,type:3});
      this.financeclassOptions = res.filter(val => val.parentId !== 0).map(item => {
        return {
          id: item.id, label: item.name
        }
      })
    },
    processData(type, data) {
      /*switch (type) {
        case 1:
          return array.filter(item => item.type === 1).reduce((sum,item) => sum+item.amount,0)
        case 2:
          return array.filter(item => item.type === 2).reduce((sum,item) => sum+item.amount,0)
        case 3:
          return array.filter(item => item.type === 3).reduce((sum,item) => sum+item.amount,0)
        case 4:
          return array.filter(item => item.type === 4).reduce((sum,item) => sum+item.amount,0)
      }*/
      switch (type) {
        case 2:
          return data.expend?.reduce((sum,item) => sum+item.amt,0).toFixed(2);
        case 1:
          return data.income?.reduce((sum,item) => sum+item.amt,0).toFixed(2);
      }
    },
    safeGetMappedValue(col, row) {
      // 1. 检查数据有效性
      const rawValue = row[col.prop];
      if (rawValue === null || rawValue === undefined) return ' ';

      // 2. 检查映射数组
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;

      // 3. 执行映射
      const matched = mapArray.find(item => item.id === rawValue);
      return matched?.label || rawValue;
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },

    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },


    getColumnWidth(label, prop, tableData) {
      const minWidth = 80;
      const padding = 30;

      // 检查数据是否已加载
      if (!tableData || !Array.isArray(tableData) || tableData.length === 0) {
        return minWidth; // 返回默认宽度
      }

      const contentList = tableData.map(item => item?.[prop] ?? '');

      const widths = [...contentList, label].map(text => {
        const str = String(text || '');
        return this.getTextWidth(str) + padding;
      });

      return Math.max(minWidth, ...widths);
    },

    // 精确计算文本宽度（使用Canvas）
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },

    labelHead(h, {column, $index}) {
      let l = column.label.length;
      let f = 12;
      column.minWidth = f * (l + 5); //加上一个文字长度
      return h("div", {class: "table-head", style: {width: "100%"}}, [
        column.label,
      ]);
    },


    handleWestDetail() {
      this.westModalVisible = false;
    },

    handleDisposeDetailModalVisible() {
      this.pageNum = 1;
      this.pageSize = 8;
      this.totalSize = 10;
      this.queryConditionForm = Object.assign({}, this.$options.data.call(this).queryConditionForm);
      this.disposeDetialModalVisible = false;
    },
    handleTimeChange(range) {
      if (range) {
        this.queryParams.startTime = range[0]
        this.queryParams.endTime = range[1]
      }
      this.loadData();
      this.loadDataStatistics();
    },

    resetQuery() {
      this.timeRange = [
        dayjs().startOf('month').format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ]
      this.queryParams.startTime = dayjs().startOf('month').format('YYYY-MM-DD')
      this.queryParams.endTime = dayjs().format('YYYY-MM-DD')
      this.loadData()
    },

    formatAmount(amount) {
      return amount?.toFixed(2);
    },

    getFeeTypeName(type) {
      const feeTypes = {
        0: '处置项目',
        1: '西药',
        2: '中药',
        3: '检查',
        4: '检验',
        5: '挂号费',
        6: '关联处置'
      }
      return feeTypes[type] || '未知类型'
    },

    getFeeTypeTagType(type) {
      const types = {
        0: '',
        1: 'success',
        2: 'warning',
        3: 'info',
        4: '',
        5: 'danger',
        6: 'info'
      }
      return types[type] || ''
    },

    getFeeTypeColor(type) {
      const colors = {
        0: '#409EFF',
        1: '#67C23A',
        2: '#E6A23C',
        3: '#909399',
        4: '#409EFF',
        5: '#F56C6C',
        6: '#909399'
      }
      return colors[type] || '#409EFF'
    },

    calculateProfitRate(row) {
      console.log(row, 'rowrowrow')
      return (row.paidAmt - row.costAmt).toFixed(2)
    },

    getProfitRateClass(row) {
      const rate = this.calculateProfitRate(row)
      if (rate > 20) return 'profit-high'
      if (rate > 10) return 'profit-medium'
      if (rate > 0) return 'profit-low'
      return 'profit-negative'
    },

    calculatePercentage(row) {
      if (this.totalPaid === 0) return 0
      return parseFloat(((row.paidAmt / this.totalPaid) * 100).toFixed(1))
    },

    async loadDataStatistics() {
      try {
        // 加载当期数据（根据当前选择的时间范围）
        const currentRes = await getFinancialDetailsStatistics({
          startTime: this.queryParams.startTime,
          endTime: this.queryParams.endTime,
        });
        this.statisticsData = currentRes.data || {};

        // 同时加载年度累计数据（从当年1月1日到最后一天）
        await this.loadYearlyStatisticsData();

      } catch (error) {
        console.error('加载统计数据失败:', error);
        this.$message.error('加载统计数据失败');
      }
    },

    async loadYearlyStatisticsData() {
      try {
        // 获取当前年份的第一天和最后一天
        const startTime = dayjs().startOf('year').format('YYYY-MM-DD');
        const endTime = dayjs().endOf('year').format('YYYY-MM-DD');

        const res = await getFinancialDetailsStatistics();
        this.yearlyStatisticsData = res.data || {};

      } catch (error) {
        console.error('加载年度统计数据失败:', error);
        // 可以不显示错误提示，避免干扰用户
      }
    },
    async loadData() {
      try {
        const res = await getFinancialDetailsPage({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          startTime: this.queryParams.startTime,
          endTime: this.queryParams.endTime,
          type: this.queryParams.type ?? null,
          classId:this.queryParams.classId ?? null
        })
        const arr = [1,2,3];
        res.data.content.forEach(item => {
          if (arr.includes(item.type)){
            item.amountPaid = item.amount;
            item.amountIncome = null;
          }else {
            item.amountIncome = item.amount;
            item.amountPaid = null;
          }
        })
        this.loadDataStatistics()
        this.getFinanceclassList()
        this.tableData = res.data.content;
        this.totalSize = res.data.totalSize;
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('加载数据失败')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.stat-content {
  position: relative;
}

.stat-title {
  position: absolute;
  top: 30px;
  left: 12px;
  font-size: 60px;
  color: #333;
}


/* 或者如果你的stat-content是flex布局 */
.stat-content {
  display: flex;
  flex-direction: column;
}

.stat-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}


.stat-card {
  border: none;
  margin: 0 10px;
  border-radius: 8px;
}

.stat-content {
  display: flex;
  align-items: center;
  height: 100%;
}

.stat-icon {
  margin-right: 15px;
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 10px;
  flex-shrink: 0;
}

/* 支出卡片样式 */
.expense-card .stat-icon {
  background-color: rgba(245, 108, 108, 0.1);
}

.expense-card .stat-icon i {
  color: #f56c6c;
}

/* 收入卡片样式 */
.income-card .stat-icon {
  background-color: rgba(103, 194, 58, 0.1);
}

.income-card .stat-icon i {
  color: #67c23a;
}

.stat-info {
  flex: 1;
  min-width: 0; /* 防止flex溢出 */
}

.stat-title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
  font-weight: 500;
}

.stat-values-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.stat-value-item {
  flex: 1;
  text-align: center;
  min-width: 0; /* 防止文本溢出 */
}

.value-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
  white-space: nowrap;
}

.stat-value {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  line-height: 1.2;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.stat-divider {
  font-size: 16px;
  color: #dcdfe6;
  font-weight: normal;
  padding: 0 5px;
  flex-shrink: 0;
}

/* 鼠标悬停效果 */
.stat-card:hover {
  transform: translateY(-2px);
  transition: transform 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .stat-value {
    font-size: 16px;
  }

  .stat-icon {
    font-size: 28px;
    width: 45px;
    height: 45px;
  }
}

@media (max-width: 992px) {
  .stat-values-row {
    flex-direction: column;
    gap: 8px;
  }

  .stat-divider {
    display: none;
  }

  .stat-value-item {
    width: 100%;
  }
}

@media (max-width: 768px) {


  .stat-icon {
    font-size: 24px;
    width: 40px;
    height: 40px;
    margin-right: 12px;
  }

  .stat-value {
    font-size: 16px;
  }

  .stat-title {
    font-size: 13px;
  }

  .value-label {
    font-size: 11px;
  }
}

@media (max-width: 576px) {
  .stat-values-row {
    flex-direction: row;
    gap: 5px;
  }

  .stat-divider {
    display: inline;
  }

  .stat-value {
    font-size: 14px;
  }

  .stat-title {
    margin-bottom: 8px;
  }
}

/* 加载状态样式 */
.stat-value.loading {
  color: #c0c4cc;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% { opacity: 0.6; }
  50% { opacity: 1; }
  100% { opacity: 0.6; }
}
/* 可选：添加渐变背景 */
.expense-card {
  border-left: 4px solid #f56c6c;
}

.income-card {
  border-left: 4px solid #67c23a;
}

/* 可选：添加阴影层次 */
.stat-card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* 可选：添加悬停动画 */
.stat-card {
  transition: all 0.3s ease;
}

/* 可选：为累计值添加不同颜色 */
.stat-value-item:last-child .stat-value {
  color: #606266;
  font-weight: 600;
}

/* 可选：为标签添加背景色 */
.value-label {
  background: #f5f7fa;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
}
/deep/ .el-dialog__title {
  font-size: 14px;
  color: #fff;
}

// 穿透
/deep/ .el-dialog__header {
  padding: 12px;
  background-color: #007bb0;
}

.patient-dialog {
  .el-dialog {
    /* 改为动态高度控制 */
    max-height: 70vh !important;
    height: auto !important; /* 关键修改 */
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 15% !important; /* 上移对话框位置 */
    left: 50%;
    transform: translateX(-50%);
    margin: 0 !important;

    .el-dialog__header {
      height: 35px !important;
      padding: 5px 15px !important;
      flex-shrink: 0; /* 防止头部被压缩 */

      .el-dialog__title {
        font-size: 12px !important;
        line-height: 25px !important;
      }
    }

    .el-dialog__body {
      flex: 1;
      overflow: hidden; /* 外层隐藏滚动 */
      display: flex;
      flex-direction: column;
      min-height: 0; /* 关键修复：允许flex子项收缩 */

      .aform, .bform {
        flex: 1;
        overflow-y: auto; /* 只在表单容器内滚动 */
        margin-bottom: 5px;
        min-height: 0; /* 关键修复 */

        .el-tabs {
          height: 100%;
          display: flex;
          flex-direction: column;
          min-height: 0; /* 关键修复 */

          .el-tabs__content {
            flex: 1;
            overflow: visible; /* 禁用嵌套滚动 */
            padding: 5px;
          }
        }
      }
    }

    .el-dialog__footer {
      height: 40px !important;
      padding: 5px !important;
      flex-shrink: 0; /* 防止底部被压缩 */

      .el-button {
        padding: 7px 15px !important;
      }
    }
  }

  /* 小屏幕适配 */
  @media (max-height: 600px) {
    .el-dialog {
      max-height: 80vh !important;
      top: 10% !important;

      .el-dialog__body {
        padding: 5px !important;
      }
    }
  }
}

.outpatient-charge-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f5f7fa;
}

/* 筛选区域 - 固定高度，不参与滚动 */
.filter-section {
  flex-shrink: 0;
  margin-bottom: 16px;
}

.filter-card {
  width: 100%;
}

/* 内容区域 - 可滚动 */
.content-section {
  flex: 1;
  min-height: 0; /* 重要：允许内容区域收缩 */
  overflow-y: auto; /* 垂直滚动 */
  display: flex;
  flex-direction: column;
  gap: 16px; /* 元素间距 */
}

/* 统计卡片行 */
.stats-row {
  margin: 0;
}

/* 标签页样式调整 */
.separate-tab {
  flex-shrink: 0; /* 防止标签页被压缩 */
}

/* 表格样式 */
.detail-table {
  width: 100%;
}

/* 统计卡片样式 */
.stat-card {
  height: 120px;
}

.stat-content {
  display: flex;
  align-items: center;
  height: 100%;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  font-size: 24px;
  color: white;
}

.cash-icon {
  background: #67C23A;
}

.paid-icon {
  background: #409EFF;
}

.cost-icon {
  background: #E6A23C;
}

.discount-icon {
  background: #F56C6C;
}

.stat-info {
  flex: 1;
}

.stat-title {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 4px;
}

.stat-desc {
  font-size: 12px;
  color: #C0C4CC;
}

/* 聚合支付卡片 */
.group-card {
  margin: 0;
}

.card-header {
  display: flex;
  align-items: center;
}

.card-title {
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.group-content {
  text-align: center;
  padding: 20px;
}

.group-amount {
  font-size: 28px;
  font-weight: bold;
  color: #409EFF;
  margin-bottom: 8px;
}

.group-desc {
  color: #909399;
  font-size: 14px;
}
</style>